import { StackDivider } from '@chakra-ui/react';
import { useWidget } from '@telescope/cassini-hooks';
import { Container, IconButton, Stack } from '@telescope/cassini-ui';
import { Link, Text } from 'components';
import { Open } from 'generated-types/widget';
import React from 'react';

import { iconMap } from './utils';

export const Footer = () => {
  const {
    data: { settings, content, styles },
  } = useWidget<Open>({ select: (data) => data.widget.globalViews.footer });

  if (!settings.isVisible) return null;

  const TextLinks = () => (
    <Stack
      className="cassini-footer__text-links"
      wrap="wrap"
      direction={'row'}
      divider={<StackDivider borderColor="current" aria-hidden="true" />}
      fontSize={{ base: 'sm', md: 'md' }}
      {...styles.textLinks}>
      {content.links.map((link: { text: string; href: string }, index: number) => {
        return (
          <Link key={index} allowMarkdown href={link.href} target="_blank" variant="unstyled">
            {link.text}
          </Link>
        );
      })}
    </Stack>
  );
  const FollowLinks = () => (
    <Stack wrap="wrap" className="cassini-footer__follow-links" direction={'row'} fontSize={30} {...styles.followLinks}>
      {content.followLinks.map((link: { icon: string; href: string; alt: string }, index: number) => {
        const { colorScheme, ...restStyles } = styles.followLinksIcon;
        const isMonochrome = colorScheme !== 'brand'; // if the colorScheme is 'brand', use the official brand icons, otherwise all icons will be monochrome based on the colorScheme

        return (
          <IconButton
            data-social-name={link.icon}
            className="cassini-footer__follow-links-icon"
            fontSize="inherit"
            variant="link"
            key={index}
            as="a"
            href={link.href}
            aria-label={link.alt}
            target="_blank"
            icon={React.createElement(iconMap[`${isMonochrome ? 'monochrome_' : ''}${link.icon}`])}
            colorScheme={colorScheme === 'brand' ? undefined : colorScheme}
            {...restStyles}
          />
        );
      })}
    </Stack>
  );

  // TODO: Once finalized, this should be added to Cassini as a new component

  return (
    <Container
      as="footer"
      className="cassini-footer"
      role="contentinfo"
      centerContent
      maxW={settings.isFullWidth ? 'full' : 'app'}
      {...styles.footer}>
      <Stack
        direction="column"
        align="center"
        className="cassini-footer__container"
        spacing={6}
        py={6}
        {...styles.footerContainer}>
        <TextLinks />
        <FollowLinks />
        <Text
          className="cassini-footer__legal-text"
          allowMarkdown
          fontSize="sm"
          color={'inherit'}
          {...styles.legalText}>
          {content.legalText}
        </Text>
      </Stack>
    </Container>
  );
};
